// Llamadas al chat de WhatsApp atendido por personas (enviar_notificacion_servicio?accion=<prefijo><accion>).
// Cada servicio aporta su prefijo: atencion_practicas_ (atencion_practicas.py) o impagos_chat_ (atencion_impagos.py).
export async function callWhatsappChatApi<T = any>(
  apiUrl: string,
  apiKey: string,
  accion: string,
  body: Record<string, unknown> = {}
): Promise<T> {
  if (!apiUrl || !apiKey) throw new Error('Faltan las variables de entorno del backend de notificaciones.');
  const response = await fetch(`${apiUrl}?code=${apiKey}&accion=${accion}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const text = await response.text();
  let data: any = null;
  try {
    data = JSON.parse(text);
  } catch {
    // Un backend sin el módulo atencion_practicas contesta "Acción no reconocida" en texto plano
    const detail = text.trim().slice(0, 200) || `Error HTTP ${response.status}`;
    throw new Error(
      detail === 'Acción no reconocida'
        ? 'El backend al que apunta la web todavía no tiene desplegada la atención por WhatsApp (Acción no reconocida).'
        : detail
    );
  }
  if (!response.ok || !data?.ok) {
    throw new Error(data?.mensaje || `Error HTTP ${response.status}`);
  }
  return data as T;
}
